import { ADD_ITEM, TERM_SWITCH, PRIVACY_SWITCH, COOKIE_SWITCH} from "./actionTypes"

const addItem = () => {
  return {
    type: ADD_ITEM,
  };
};

const termSwitch = () => {
  return {
    type: TERM_SWITCH,
  };
};


const privacySwitch = () => {
  return {
    type: PRIVACY_SWITCH,
  };
};

const cookieSwitch = () => {
  return {
    type: COOKIE_SWITCH,
  };
};

export {addItem , termSwitch, privacySwitch, cookieSwitch}